<template>
    <el-container>
        <el-header>
            <sub-header></sub-header>
        </el-header>
        <el-container class="inner-container">
            <el-aside class="sub-menu-box" v-if="checkAsideShow()">
                <sub-aside></sub-aside>
            </el-aside>
            <el-main id="page-main">
                <div class="sub-breadcrumb" id="page-main-breadcrumb" v-html="breadcrumbHandle()"></div>
                <div class="loading-private" id="loading-private" v-show="$loadingPrivate">
                    <div class="loading-private-wrap"></div>
                    <div class="loading-private-animate"></div>
                </div>
                <div class="sub-content-box" id="page-main-content" :style="getPadding()">
                    <div class="sub-content">
                        <slot></slot>
                    </div>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
    name: "layout",
    props: ["padding"],
    date() {},
    computed: {
        ...mapState([
            "$md5",
            "$base64",
            "$page",
            "$lodash",
            "$helper",
            "$loading",
            "$title",
            "$routerMapsDefined",
            "$loadingPrivate",
            "$jquery",
            "$iframeHeight",
            "$jumpProjectTypeRoute1",
            "$jumpProjectTypeRoute2",
            "$isAdmin"
        ])
    },

    created() {
        this.GET_ACTIVE_GAME_INFO();
    },

    mounted() {
        this.LOADING(false);
        this.SAVE_VUE_OBJECT(this);
        document.title = this.$title;
        // console.log(this.$loadingPrivate)

        this.getContentHeight();
        this.$jquery(window).resize(() => {
            this.getContentHeight();
        });
    },
    watch: {
        $loading(val) {
            let loading = document.getElementById("loading");
            if (val) loading.style.display = "block";
            else loading.style.display = "none";
        },

        $title(val) {
            document.title = val;
        }
    },
    methods: {
        ...mapActions(["LOADING", "SAVE_VUE_OBJECT", "GET_ACTIVE_GAME_INFO"]),
        ...mapMutations(["SET_CONTENT_HEIGHT"]),

        checkAsideShow() {
            /** 管理员**/
            if (this.$isAdmin) {
                return true;
            }

            /** 用户有业务和发行入口权限**/
            if (this.$jumpProjectTypeRoute1 || this.$jumpProjectTypeRoute2) {
                return true;
            }

            /** 用户无业务和发行入口权限**/
            return false;
        },

        getContentHeight() {
            let height =
                this.$jquery(window).height() -
                this.$jquery(".el-header").outerHeight();
            height =
                height -
                this.$jquery("#page-main-breadcrumb").outerHeight() -
                8;
            // console.log(height);
            this.SET_CONTENT_HEIGHT(height);
        },

        getPadding() {
            if (!this.padding) return;
            else `padding:${this.padding}`;
        },

        /**
         * 设置面包屑
         */
        breadcrumbHandle() {
            let pathArr = this.$page.split("/");
            if (pathArr.length === 1) {
                return `<span class="route-parent">${
                    this.$routerMapsDefined[this.$page]["title"]
                }</span>`;
            }
            // console.log('111111',pathArr);
            let indexName = this.$routerMapsDefined[pathArr[0]]["title"];
            let pageName = "";
            let pageParentNameHtml = "";
            let children = this.$routerMapsDefined[pathArr[0]]["children"];
            let gameCode = this.$helper.helper.getGameCode();
            gameCode = gameCode.game_code;
            for (let key in children) {
                if (pathArr[1] === key) {
                    pageName = children[key]["title"];
                    if (pathArr[1] !== children[key]["active"]) {
                        let parentRoute = pathArr[0];
                        let parentPage = children[children[key]["active"]];
                        pageParentNameHtml = `<a href="/${parentRoute}/${parentPage.url}?game_code=${gameCode}">${parentPage.title}</a><strong> <i class="el-icon-arrow-right"></i> </strong>`;
                    }
                    break;
                }
            }
            if (this.$helper.helper.parseURL().params.id && pageName === '新增') {
                pageName = '编辑';
                document.title = document.title.replace('ODP5发行平台 - 新增', 'ODP5发行平台 - 编辑');
            }
            return `<i class="el-icon-s-home"></i> <span class="route-parent">${indexName}</span><strong> <i class="el-icon-arrow-right"></i> </strong>${pageParentNameHtml}<span class="route-page">${pageName}</span>`;
        }
    }
};
</script>

<style type="scss">
#slimvue-app {
    height: 100%;
}
.el-container {
    height: 100%;
}
.inner-container {
    height: 100%;
    height: -moz-calc(100% - 60px);
    height: -webkit-calc(100% - 60px);
    height: calc(100% - 60px);
    overflow: hidden;
}

.el-aside {
    width: 260px !important;
    border-right: 1px solid #ccc;
}

.el-main {
    background: #f4f4f4;
    padding: 0 !important;
    position: relative;
    height: 100%;
}

.noaccess {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-size: 25px;
    font-weight: bold;
    line-height: 40px;
    padding: 250px 0;
    text-align: center;
}

.el-header {
    padding: 0;
}

/* .sub-content-box {
} */

.sub-content {
    background: #fff;
    height: 100%;
}

.sub-breadcrumb {
    box-sizing: border-box;
    height: 50px;
    background: #fff;
    font-size: 14px;
    padding: 0 25px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    min-width: 740px;
}

.sub-breadcrumb strong {
    padding: 0 5px;
    color: #999;
}

.sub-breadcrumb a {
    color: #333;
}

.sub-breadcrumb .route-page {
    color: #999;
}
.sub-content-box {
    min-width: 740px;
}

.el-icon-document-copy {
    cursor: pointer;
    &:hover {
        color: #5cb6ff;
    }
}
</style>
<style>
    @font-face {
        font-family: "iconfont"; /* Project id 2663860 */
        src: url('../fonts/iconfont.woff2?t=1626260334856') format('woff2'),
        url('../fonts/iconfont.woff?t=1626260334856') format('woff'),
        url('../fonts/iconfont.ttf?t=1626260334856') format('truetype');
    }
    @font-face {
        font-family: "iconfont"; /* Project id 2663860 */
        src: url('../fonts/iconh5.woff2?t=1626260334856') format('woff2'),
        url('../fonts/iconh5.woff?t=1626260334856') format('woff'),
        url('../fonts/iconh5.ttf?t=1626260334856') format('truetype');
    }



    .iconfont {
        font-family: "iconfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .iconAndroid:before {
        content: "\e636";
    }

    .iconios:before {
        content: "\e681";
    }
    .iconh5:before {
        content: "\e633";
    }
    .iconwindows:before {
        content: "\e882";
    }

</style>



// WEBPACK FOOTER //
// website/subComponents/layout.vue